import { Fragment, useState } from 'react'
import { Checkbox, InputLabel, WithTheme } from '@opallabs/lapidary'
import { GenerateContentInput } from './GenerateContentInput'
import * as styles from './styles'

export type PromptProps = {
  useContext: boolean
  prompt: string
}

export type GenerateContentProps = WithTheme & {
  inModal?: boolean
  onSetPrompt: (promptObject: PromptProps) => void
}

export const GenerateContent: React.FC<GenerateContentProps> = ({
  onSetPrompt,
  theme = 'dark',
}) => {
  const [useContext, setUseContext] = useState<boolean>(true)
  const [prompt, setPrompt] = useState<string>('')

  return (
    <Fragment>
      <div css={styles.checkboxOption}>
        <Checkbox
          checked={useContext}
          htmlId="includeContext"
          onChange={() => {
            setUseContext(!useContext)
            onSetPrompt({ useContext: !useContext, prompt })
          }}
          theme={theme}
        />
        <InputLabel
          inputId="includeContext"
          text="Use surrounding content and notes as context"
          theme={theme}
        />
      </div>
      <GenerateContentInput
        label="Additional content details"
        onChange={(value: string) => {
          setPrompt(value)
          onSetPrompt({ useContext, prompt: value })
        }}
        placeholder={
          'Include a 20% discount for...\nTarget people who are interested in...\nHighlight these benefits...'
        }
        theme={theme}
      />
    </Fragment>
  )
}
